import { useEffect } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { H1, VStack } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/shared-components';
import { useNavigate } from 'react-router-dom';

import { AssignToExistingPurpose } from './components/AssignToExistingPurpose';
import { CreateNewPurposeButton } from './components/CreateNewPurposeButton';

import { PurposeCreationIntent } from '../../../graphql/schema';
import Footer from '../../../Shared/components-v2/footer/Footer';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { usePurposeSelectionStep } from '../FlowConfig';
import { ExistingPurposesDocument } from '../graphql/query.existingPurposes.generated';

const SELECTION_TO_TYPED_PURPOSE = {
  emergency_fund: PurposeCreationIntent.EmergencyFund,
  retirement: PurposeCreationIntent.Retirement,
  major_purchase: PurposeCreationIntent.MajorPurchase,
};

export const AssignmentStep: React.FC = () => {
  const navigate = useNavigate();
  const { commit, dependencies } = usePurposeSelectionStep('assignment');
  const { data } = useGraphQLQuery(ExistingPurposesDocument, {
    variables: { intent: SELECTION_TO_TYPED_PURPOSE[dependencies.selection.purposeType] },
    throwOnError: true,
  });

  useEffect(() => {
    if (data?.purposes.length === 0) {
      void navigate(urlBuilder.appRedirectToPurposeFlow({ purposeType: dependencies.selection.purposeType }), {
        replace: true,
      });
    }
  }, [data, navigate, dependencies]);

  if (!data || data.purposes.length === 0) {
    return null;
  }

  const handleNextStep = (purposeId: string) => {
    commit({ purposeId });
    // void navigate('/app');
  };

  return (
    <WorkflowLayout pageTitle="">
      <WorkflowLayout.Header workflowTitle={null} onBack={() => navigate(-1)} onClose={() => navigate('/')} />
      <WorkflowLayout.Content>
        <H1 variant="pageTitle" css={{ mb: 'space.300' }}>
          Do you want to assign this account to your existing goal?
        </H1>
        <VStack css={{ gap: 'space.150', mb: 'space.300' }}>
          {data.purposes.map(purpose => (
            <AssignToExistingPurpose purpose={purpose} handleAssignment={handleNextStep} key={purpose.id} />
          ))}
        </VStack>
        <CreateNewPurposeButton purposeType={dependencies.selection.purposeType} />
      </WorkflowLayout.Content>
      <WorkflowLayout.Footer>
        <Footer />
      </WorkflowLayout.Footer>
    </WorkflowLayout>
  );
};
